import { Action } from 'redux';

import { CreateFlowSubscription } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ISpaceItemDetailInfo } from '../../spacesPlatform/models/ISpaceItemDetailInfo';

export interface CreateFlowSubscriptionReduxAction extends Action {
  readonly flow: IContentInfo;
}

export function createFlowSubscription(flow: IContentInfo | ISpaceItemDetailInfo<'flow'>): CreateFlowSubscriptionReduxAction {
  return {
    type: CreateFlowSubscription,
    flow
  };
}
